import SharedPropsService from "../../SharedPropsService";
import { ROUTE } from "../../routes";
import { AppLink } from "../../configs/constants";
import { rebuildLeadsTable, searchObject, sideBarNavigate, sortPartnerObjectByProperty, TableDataBuilder, } from "../dashboard/utils";
import { rebuildLeadMobileCardBuilder } from "../utils";
import { ColorTokens, WIDGET } from "@voltmoney/schema";
let PartnerLeadsData = [];
let tableSearchString = '';
let ascOrder = true;
let newCounter = 1;
let array = [];
let appendArray = [];
let appendDefinedValues = [];
export const onSearchLead = async (action, _datastore, standardUtilities) => {
    tableSearchString = action.payload.value;
    const PartnerLeadsDataOriginal = await SharedPropsService.getPlatformLeadsList();
    if (tableSearchString === "") {
        await standardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, "leadTable", {
            titleMap: {
                ...TableDataBuilder(appendDefinedValues).Title_MAP,
            },
            titleConfig: {
                ...TableDataBuilder(appendDefinedValues)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...TableDataBuilder(appendDefinedValues).DATA,
            },
            data: appendDefinedValues,
        });
        await standardUtilities.appendWidgets(ROUTE.PLATFORM_LEADS, {
            ...TableDataBuilder(appendDefinedValues).DATA_STORE,
        }, [
            {
                id: "referredPartnerTableStack11", type: WIDGET.STACK
            }
        ], "spaceStack");
        if (newCounter === 1) {
            await standardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, "leadTable", {
                titleMap: {
                    ...TableDataBuilder(PartnerLeadsDataOriginal.slice(0, 50)).Title_MAP,
                },
                titleConfig: {
                    ...TableDataBuilder(PartnerLeadsDataOriginal.slice(0, 50))
                        .TITLE_CONFIG,
                },
                widgetData: {
                    ...TableDataBuilder(PartnerLeadsDataOriginal.slice(0, 50)).DATA,
                },
                data: PartnerLeadsDataOriginal.slice(0, 50),
            });
            await standardUtilities.appendWidgets(ROUTE.PLATFORM_LEADS, {
                ...TableDataBuilder(PartnerLeadsDataOriginal.slice(0, 50)).DATA_STORE,
            }, [
                {
                    id: "referredPartnerTableStack11", type: WIDGET.STACK
                }
            ], "spaceStack");
        }
    }
    else {
        PartnerLeadsData = PartnerLeadsDataOriginal?.filter(data => {
            const results = searchObject(data, tableSearchString);
            if (results &&
                results.length > 0) {
                return true;
            }
            else {
                return false;
            }
        });
        if (action.payload.widgetId === 'leadSeachInput') {
            await rebuildLeadsTable(standardUtilities, PartnerLeadsData, action);
        }
        if (action.payload.widgetId === 'leadsMobRootSearchInput') {
            await rebuildLeadMobileCardBuilder(standardUtilities, PartnerLeadsData);
        }
    }
};
export const onSortLeads = async (action, _datastore, standardUtilities) => {
    console.warn('**** onSortLeads leads Action Triggered ****', action);
    PartnerLeadsData = sortPartnerObjectByProperty(PartnerLeadsData, action.payload.value, ascOrder);
    ascOrder = !ascOrder;
    await rebuildLeadsTable(standardUtilities, PartnerLeadsData, action);
};
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    console.warn('**** onChangeTab leads Action Triggered ****', action);
    await sideBarNavigate(standardUtilities, action);
};
export const onLoadMoreData = async (action, _datastore, standardUtilities) => {
    console.warn('**** onLoadMoreData leads Action Triggered ****', action);
};
export const onTrackCustomerJourney = async (action, _datastore, standardUtilities) => {
    console.warn('**** onLoadMoreData leads Action Triggered ****', action);
    const user = action.payload.value;
    const borrowerAccountId = user?.creditApplication.accountId;
    // await standardUtilities.navigate(ROUTE.REGISTER_LEADS_SUCCESS, {user: action.payload.value});
    await standardUtilities.navigate(ROUTE.VOLT_APP, { borrowerAccountId: borrowerAccountId });
};
export const viewDetails = async (action, _datastore, standardUtilities) => {
    console.warn('**** viewDetails Action Triggered ****', action);
    const user = action?.payload.user;
    if (user) {
        standardUtilities.navigate(ROUTE.PLATFORM_VIEW_DETAILS, { user: user, leads: true });
    }
};
export const onShareLink = async (action, _datastore, standardUtilities) => {
    console.warn('**** onShareLink Action Triggered ****', action);
    const user = action?.payload.user;
    console.log("User 123: ", user);
    const phoneNumber = user.borrowerAccountProfile.phoneNumber ? user.borrowerAccountProfile.phoneNumber : '';
    const link = `${AppLink}?user=${phoneNumber.slice(3)}`;
    if (user) {
        standardUtilities.navigate(ROUTE.INVITE_CLIENT, { _link: link, _title: 'Directly share the Volt Money app link with your customers.', _headerTitle: 'Share link with client', _removeBanner: true });
    }
};
export const appendCounter = async (action, _datastore, { setDatastore, appendWidgets }) => {
    array = action.payload.array;
    const totalNoOfPages = action.payload.totalNoOfPages;
    if (newCounter !== totalNoOfPages) {
        newCounter = newCounter + 1;
        await setDatastore(ROUTE.PLATFORM_LEADS, "nextText", {
            color: ColorTokens.Grey_Night
        });
        await setDatastore(ROUTE.PLATFORM_LEADS, "rightIcon", {
            color: ColorTokens.Grey_Night
        });
        if (newCounter > 1) {
            await setDatastore(ROUTE.PLATFORM_LEADS, "previousText", {
                color: ColorTokens.Grey_Night
            });
            await setDatastore(ROUTE.PLATFORM_LEADS, "leftIcon", {
                color: ColorTokens.Grey_Night
            });
        }
        else {
            await setDatastore(ROUTE.PLATFORM_LEADS, "previousText", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_LEADS, "leftIcon", {
                color: ColorTokens.Grey_Charcoal
            });
        }
        await setDatastore(ROUTE.PLATFORM_LEADS, "currentPageNumber", {
            label: `Page ${newCounter}`,
        });
        await setDatastore(ROUTE.PLATFORM_LEADS, "spaceStack", {
            hide: false
        });
        const pageNumber = newCounter;
        const valuesToShowPerPage = 50;
        const startValue = (pageNumber - 1) * valuesToShowPerPage + 1;
        const endValue = pageNumber * valuesToShowPerPage;
        appendArray = [];
        for (let i = startValue; i <= endValue; i++) {
            appendArray.push(array[i]);
        }
        appendDefinedValues = appendArray.filter((value) => value !== undefined);
        await setDatastore(ROUTE.PLATFORM_LEADS, "leadTable", {
            titleMap: {
                ...TableDataBuilder(appendDefinedValues).Title_MAP,
            },
            titleConfig: {
                ...TableDataBuilder(appendDefinedValues)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...TableDataBuilder(appendDefinedValues).DATA,
            },
            data: appendDefinedValues,
        });
        await appendWidgets(ROUTE.PLATFORM_LEADS, {
            ...TableDataBuilder(appendDefinedValues).DATA_STORE,
        }, [
            {
                id: "referredPartnerTableStack11", type: WIDGET.STACK
            }
        ], "spaceStack");
        if (newCounter === totalNoOfPages) {
            await setDatastore(ROUTE.PLATFORM_LEADS, "nextText", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_LEADS, "rightIcon", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_LEADS, "previousText", {
                color: ColorTokens.Grey_Night
            });
            await setDatastore(ROUTE.PLATFORM_LEADS, "leftIcon", {
                color: ColorTokens.Grey_Night
            });
        }
    }
    else {
        await setDatastore(ROUTE.PLATFORM_LEADS, "nextText", {
            color: ColorTokens.Grey_Charcoal
        });
        await setDatastore(ROUTE.PLATFORM_LEADS, "rightIcon", {
            color: ColorTokens.Grey_Charcoal
        });
        await setDatastore(ROUTE.PLATFORM_LEADS, "previousText", {
            color: ColorTokens.Grey_Night
        });
        await setDatastore(ROUTE.PLATFORM_LEADS, "leftIcon", {
            color: ColorTokens.Grey_Night
        });
    }
};
export const minusCounter = async (action, _datastore, { setDatastore, appendWidgets }) => {
    if (newCounter > 1) {
        newCounter = newCounter - 1;
        await setDatastore(ROUTE.PLATFORM_LEADS, "currentPageNumber", {
            label: `Page ${newCounter}`,
        });
        const pageNumber = newCounter;
        const valuesToShowPerPage = 50;
        const startValue = (pageNumber - 1) * valuesToShowPerPage + 1;
        const endValue = pageNumber * valuesToShowPerPage;
        appendArray = [];
        for (let i = startValue; i <= endValue; i++) {
            appendArray.push(array[i]);
        }
        appendDefinedValues = appendArray.filter((value) => value !== undefined);
        await setDatastore(ROUTE.PLATFORM_LEADS, "leadTable", {
            titleMap: {
                ...TableDataBuilder(appendDefinedValues).Title_MAP,
            },
            titleConfig: {
                ...TableDataBuilder(appendDefinedValues)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...TableDataBuilder(appendDefinedValues).DATA,
            },
            data: appendDefinedValues,
        });
        await setDatastore(ROUTE.PLATFORM_LEADS, "spaceStack", {
            hide: false
        });
        await appendWidgets(ROUTE.PLATFORM_LEADS, {
            ...TableDataBuilder(appendDefinedValues).DATA_STORE,
        }, [
            {
                id: "referredPartnerTableStack11", type: WIDGET.STACK
            }
        ], "spaceStack");
        if (newCounter === 1) {
            await setDatastore(ROUTE.PLATFORM_LEADS, "previousText", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_LEADS, "leftIcon", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_LEADS, "nextText", {
                color: ColorTokens.Grey_Night
            });
            await setDatastore(ROUTE.PLATFORM_LEADS, "rightIcon", {
                color: ColorTokens.Grey_Night
            });
        }
    }
};
